import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-bill-alert',
  templateUrl: './bill-alert.component.html',
  styleUrls: ['./bill-alert.component.scss']
})
export class BillAlertComponent implements OnInit {

  product_list: any;
  product_data: any;

  constructor(public dialogRef: MatDialogRef<BillAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.product_list = Object.keys(data['return_data']);
    this.product_data = data['return_data'];
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
